var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('p',[_vm._v(" This page does not exist. "),_c('a',{attrs:{"href":"#","onclick":"history.go(-1)"}},[_vm._v("Go Back")])])])
}]

export { render, staticRenderFns }